export const getAlertsList = (state) => state.alerts.alerts;
export const getAlertsCriterias = (state) => state.alerts.criterias;
export const getAlertsUnread = (state) => state.alerts.unreadAlerts;

